<template>
    <el-dialog title="充值" :visible.sync="dialogVisible" width="768px" :before-close="handleClose">
        <div class="main">
            <el-form :model="ruleForm"  ref="ruleForm" label-width="140px" class="demo-ruleForm">
                <el-form-item label="充值金额：" prop="price">
                    <el-input
                        v-model="ruleForm.price"
                        placeholder="请输入充值金额（元）"
                        oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                        clearable
                    ></el-input>
                </el-form-item>
                <el-form-item label="支付类型：" prop="type">
                    <el-radio-group v-model="ruleForm.type" :disabled="opt" @change="codeChange">
                        <el-radio label="1">支付宝</el-radio>
                        <el-radio label="2">微信</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="" class="right">
                    <div class="img">
                        <div
                            class="div"
                            style="width: 140px; height: 140px"
                            v-loading="urlLoad"
                            element-loading-text="加载中"
                            element-loading-spinner="el-icon-loading"
                            element-loading-background="rgba(0, 0, 0, 0.8)"
                        >
                            <vue-qr :text="qrUrl" qid="testid" :margin="0" v-if="qrUrl || show"></vue-qr>
                        </div>
                    </div>
                </el-form-item>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">关 闭</el-button>
            <el-button type="primary" @click="codeChange" :loading="urlLoad">去支付</el-button>
        </span>
    </el-dialog>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import VueQr from "vue-qr";
export default {
    data() {
        return {
            dialogVisible: false,
            ruleForm: {
                price: "",
                type: "1",
            },
            rules: {
                price: [{ required: true, message: "请输入充值金额", trigger: "blur" }],
                type: [{ required: true, message: "请选择支付类型", trigger: "change" }],
            },
            urlLoad: false,
            qrUrl: "",
            timer: null,
            opt: false,
            show: false,
        };
    },
    components: { VueQr },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    methods: {
        ...mapActions({
            couponsCreateOrder: "detect/couponsCreateOrder",
            getPayment: "activity/getPayment",
            getPayQuery: "activity/getPayQuery",
        }),
        onSubmit() {
            this.show = true;
            this.urlLoad = true;
            let params = {
                token: this.getToken,
                amount: this.ruleForm.price,
                type: this.ruleForm.type,
            };
            this.couponsCreateOrder(params).then(({ data }) => {
                console.log(data);
                if (data.code == 1) {
                    this.Pay(data.data.payment_id);
                } else {
                    this.$message.error(data.msg);
                    this.show = false;
                    this.urlLoad = false;
                }
            });
        },
        checkPay(id) {
            let opt = {
                id: id,
                token: this.getToken,
            };
            this.getPayQuery(opt).then(({ data }) => {
                if (data.code == 1) {
                    if (data.data.status == 2) {
                        clearInterval(this.timer);
                        this.$message.success("支付成功！");
                        this.dialogVisible = false;
                        this.$emit("init");
                    } else if (data.data.status == 3) {
                        clearInterval(this.timer);
                        this.$message.error("支付失败！");
                    }
                }
            });
        },
        Pay(id) {
            this.opt = true;
            this.getPayment({ id: id }).then(({ data }) => {
                this.opt = false;
                clearInterval(this.timer);
                this.urlLoad = false;
                if (data.code == 1) {
                    this.qrUrl = data.data.pay_url;
                    if (!data.data.pay_url) {
                        this.$message.warning("已提交过申请，请等待审核！");
                        this.imgDialog = false;
                    } else {
                        this.qrUrl = data.data.pay_url;
                        this.urlLoad = false;
                        let i = 0;
                        this.timer = setInterval(() => {
                            this.checkPay(id);
                            i++;
                            if (i >= 20) {
                                clearInterval(this.timer);
                            }
                        }, 3000);
                    }
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        codeChange() {
            if (this.ruleForm.price == "") return this.$message.warning("请输入充值金额");
            this.onSubmit();
        },
        handleClose() {
            this.dialogVisible = false;
            this.ruleForm = {
                price: "",
                type: "1",
            };
            clearInterval(this.timer);
            this.urlLoad = false;
            this.qrUrl = "";
            this.show = false;
            this.$refs.ruleForm.resetFields();
        },
        beforeDestroy() {
            clearInterval(this.timer);
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    height: 400px;
    width: 90%;
}
.right {
    flex: 1;
    display: flex;
    align-items: center;
    .img {
        img,
        .el-image {
            width: 140px;
            height: 140px;
            background: #eee;
            font-size: 36px;
            display: flex;
            justify-content: center;
            align-items: center;
        }
    }
    .price_right {
        text-align: left;
        h4 {
            font-size: 18px;
            margin-bottom: 14px;
            span {
                font-size: 24px;
            }
        }
        p {
            padding-left: 4px;
            font-size: 14px;
        }
    }
}
</style>